module.exports = __webpack_public_path__ + "static/assets/cf3f83a5d14e3569d13ebf9723e7338c.png";